/* beautiful-react-hooks version: 0.27.4 */
import useStorage from './useStorage.js';

var useSessionStorage = useStorage('session');

export default useSessionStorage;
